<template>
  <g>
    <path
      d="M20 18.0002V16.0002C20 15.4502 19.55 15.0002 19 15.0002C18.45 15.0002 18 15.4502 18 16.0002V18.0002H16C15.45 18.0002 15 18.4502 15 19.0002C15 19.5502 15.45 20.0002 16 20.0002H18V22.0002C18 22.5502 18.45 23.0002 19 23.0002C19.55 23.0002 20 22.5502 20 22.0002V20.0002H22C22.55 20.0002 23 19.5502 23 19.0002C23 18.4502 22.55 18.0002 22 18.0002H20Z"
    />
    <path
      d="M19 4.00018C18.45 4.00018 18 4.45018 18 5.00018V12.0002C18 12.5502 18.45 13.0002 19 13.0002C19.55 13.0002 20 12.5502 20 12.0002V5.00018C20 4.45018 19.55 4.00018 19 4.00018Z"
    />
    <path
      d="M5 20.0002C5.55 20.0002 6 19.5502 6 19.0002V5.00018C6 4.45018 5.55 4.00018 5 4.00018C4.45 4.00018 4 4.45018 4 5.00018V19.0002C4 19.5502 4.45 20.0002 5 20.0002Z"
    />
    <path
      d="M12 8.00018C12.55 8.00018 13 7.55018 13 7.00018V5.00018C13 4.45018 12.55 4.00018 12 4.00018C11.45 4.00018 11 4.45018 11 5.00018V7.00018C11 7.55018 11.45 8.00018 12 8.00018Z"
    />
    <path
      d="M12 14.0002C12.55 14.0002 13 13.5502 13 13.0002V11.0002C13 10.4502 12.55 10.0002 12 10.0002C11.45 10.0002 11 10.4502 11 11.0002V13.0002C11 13.5502 11.45 14.0002 12 14.0002Z"
    />
    <path
      d="M12 20.0002C12.55 20.0002 13 19.5502 13 19.0002V17.0002C13 16.4502 12.55 16.0002 12 16.0002C11.45 16.0002 11 16.4502 11 17.0002V19.0002C11 19.5502 11.45 20.0002 12 20.0002Z"
    />
  </g>
</template>
